<template>
  <div v-if="!isReported">
    <p class="u-mb-4">
      Pour quelle raison souhaitez-vous signaler ce contenu ?
    </p>
    <form
      autocomplete="off"
      @submit.prevent="submit"
    >
      <div class="c-form__group u-mb-5">
        <select
          id="warnType"
          v-model="warnType"
          name="warnType"
          class="c-form__select"
          required
        >
          <option
            value
            disabled
            selected
          >
            Sélectionnez une raison
          </option>
          <option
            v-for="reason in reasons"
            :key="reason.id"
            :value="reason.id"
          >
            {{ reason.name }}
          </option>
        </select>
        <div
          v-if="errorMessage"
          class="is-invalid u-mt-2"
        >
          {{ errorMessage }}
        </div>
      </div>
      <div class="u-d-f u-jc-fe">
        <ButtonSimple
          type="submit"
          label="Envoyer"
          :disabled="loading"
        />
      </div>
    </form>
  </div>
  <div v-else>
    <p class="u-mb-5">
      <strong>Merci pour votre vigilance</strong>
      <br />
      <br />
      Les équipes We Are PlayStation ont été alertées par email pour contrôler
      immédiatement ce contenu et le bloquer si il s’avère offensant.
    </p>
    <div class="u-d-f u-jc-fe">
      <ButtonSimple
        label="Fermer"
        @click="vfm.closeAll()"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useVfm } from 'vue-final-modal'
import type { WarnType } from '~/types'

const vfm = useVfm()

const props = defineProps<{
  type: string
  slug: string
}>()

const { markReported } = useMyWarns()

const errorMessage = ref('')
const loading = ref(false)
const isReported = ref(false)
const warnType = ref('')

const submit = async () => {
  errorMessage.value = ''
  loading.value = true
  isReported.value = false

  const { error } = await useCustomFetch(
    API.POST_WARN.replace('$type', props.type).replace('$slug', props.slug),
    {
      method: 'POST',
      body: {
        type_id: warnType.value,
      },
    },
  )

  if (error.value) {
    if (error.value.statusCode === 409) {
      errorMessage.value = 'Ce contenu a déjà été signalé.'
      // one report per Waper and content: « Signaler » is greyed out for them from now on
      if (error.value.data?.message === 'User already warned.') {
        markReported(props.type, props.slug)
      }
    } else {
      errorMessage.value =
        'Une erreur est survenue, veuillez réessayer ultérieurement.'
    }
  } else {
    isReported.value = true
    markReported(props.type, props.slug)
  }
  loading.value = false
}

const reasons = ref<WarnType[]>([])

onMounted(async () => {
  await nextTick()

  track('popupPage', {
    popupName: '/popup/signalement',
  })

  const { data, error } = await useCustomFetch<WarnType[]>(API.GET_WARN_TYPE)

  if (error.value) {
    console.error(error.value)
  }

  reasons.value = data.value ?? []
})
</script>

<style lang="scss" scoped>
.is-invalid {
  color: #ea5151;
}
</style>
